<template>
  <v-row>
    <v-col class="mb-4">
        <v-tabs align-with-title>
          <v-tab to="/user/preferences/marketing" exact>Marketing</v-tab>
          <!-- <v-tab to="/admin/data/products/download" exact>Downloads</v-tab>
          <v-tab to="/admin/data/products/archived" exact>Archived</v-tab> -->
        </v-tabs>
      <router-view class="view" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  async created () {}
}
</script>
